export default {"src":"/_next/static/media/44-icon.7ab44695.svg","height":32,"width":46,"blurWidth":0,"blurHeight":0};